module.exports = __webpack_public_path__ + "img/3.6a1c0fa3.png";